/**
 * Environment configuration for the SMART on FHIR app.
 *
 * SECURITY NOTE: This file contains only PUBLIC configuration.
 * Client credentials, secrets, and tokens are NEVER stored here.
 * All sensitive operations are handled by the backend.
 *
 * BASIC AUTH: Credentials are injected via environment variables from GitHub secrets.
 */
// Determine backend URL based on environment
const getBackendUrl = () => {
    var _a;
    if (typeof window !== 'undefined' && ((_a = window.__ENV) === null || _a === void 0 ? void 0 : _a.REACT_APP_BACKEND_URL)) {
        return window.__ENV.REACT_APP_BACKEND_URL;
    }
    // Use environment variable if available (set by webpack)
    if (process.env.REACT_APP_BACKEND_URL) {
        return process.env.REACT_APP_BACKEND_URL;
    }
    // Development default
    if (process.env.NODE_ENV === 'development') {
        return 'https://dev-osaloaderservice.resmed.com';
    }
    // Production: Backend should be on same domain or explicitly configured
    return 'https://dev-osaloaderservice.resmed.com';
};
/** Locale served when nothing else is configured or matched. */
export const DEFAULT_LOCALE = 'en-US';
/**
 * Resolves the locales the app is allowed to serve, as a comma-separated
 * whitelist (e.g. "en-US,en-GB").
 *
 * Translation completeness is tracked in Lokalise, not in this repo: a locale
 * is added here only once Lokalise reports it 100% translated and the pulled
 * strings have landed. Dropping a locale from the list is therefore a config
 * change with no code change — and because an excluded locale is never
 * registered, its users get DEFAULT_LOCALE in full rather than a UI with blank
 * strings where translations are missing.
 */
const getSupportedLocales = () => {
    var _a;
    const raw = (typeof window !== 'undefined' ? (_a = window.__ENV) === null || _a === void 0 ? void 0 : _a.REACT_APP_SUPPORTED_LOCALES : undefined) ||
        process.env.REACT_APP_SUPPORTED_LOCALES ||
        DEFAULT_LOCALE;
    const locales = raw
        .split(',')
        .map((locale) => locale.trim())
        .filter(Boolean);
    // DEFAULT_LOCALE is always served, so a missing or malformed value can never
    // leave the app without any translations at all.
    return Array.from(new Set([DEFAULT_LOCALE, ...locales]));
};
export const config = {
    backendUrl: getBackendUrl(),
    debug: process.env.NODE_ENV === 'development',
    basicAuthUsername: process.env.REACT_APP_BASIC_AUTH_USERNAME,
    basicAuthPassword: process.env.REACT_APP_BASIC_AUTH_PASSWORD,
    supportedLocales: getSupportedLocales()
};
